
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import { AppProps } from 'next/app';
import '@fontsource/oswald';
import '@fontsource/source-sans-pro';
import '@/styles/globals.css';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import {
  Hydrate,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ChangeDomainSuggestion } from '@/components/ui/ChangeCountrySuggestion';
import { Tracking } from '@/components/Analytics/Tracking';
import ReloadOnError from '@/components/ui/ErrorBoundary';
import Loader from '@/components/ui/Loader';
import { UserProvider } from '@auth0/nextjs-auth0/client';
import { useGclid } from '@/lib/hooks/useGclid';
const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/lib/index.prod.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

function MyApp({
  Component,
  pageProps,
}: AppProps<{ dehydratedState: unknown }>) {
  const [queryClient] = useState(() => new QueryClient());
  const [showDevtools, setShowDevtools] = React.useState(false);
  useGclid();
  useEffect(() => {
    // Run "window.toggleDevtools()" in the console to toggle devtools ( even in production or staging, it will download the devtolls when executed )
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <ReloadOnError>
      <UserProvider>
        <QueryClientProvider client={queryClient}>
          <Hydrate state={pageProps.dehydratedState}>
            <Provider store={store}>
              <Loader />
              <Component {...pageProps} />
              <Tracking />
              <ChangeDomainSuggestion />
            </Provider>
            {showDevtools && (
              <React.Suspense fallback={null}>
                <ReactQueryDevtoolsProduction />
              </React.Suspense>
            )}
            <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
          </Hydrate>
        </QueryClientProvider>
      </UserProvider>
    </ReloadOnError>
  );
}

const __Page_Next_Translate__ = MyApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  